/**
 * utils/error.ts を比較的タイプセーフに使えるようにしたもの
 */
import { getMessageByFieldName } from '@/models/error';
import type { ValidationErrorObj } from '@/models/error';

interface UseValidationError<FormType> {
  errors: Ref<ValidationErrorObj[]>;
  setErrors: (e: ValidationErrorObj[]) => void;
  getErrorMessage: (s: keyof FormType) => string;
  hasError: ComputedRef<boolean>;
}

// TODO: remove type any
// eslint-disable-next-line
export const useValidationError = <FormType extends Record<string, any>>(): UseValidationError<FormType> => {
  const errors = ref<ValidationErrorObj[]>([]);

  const setErrors = (e: ValidationErrorObj[]) => {
    errors.value = e;
  };

  const getErrorMessage = (fieldName: keyof FormType): string => {
    return getMessageByFieldName(errors.value, fieldName as string);
  };

  const hasError = computed(() => errors.value.length > 0);

  return { errors, setErrors, getErrorMessage, hasError };
};
